import { Box, Dialog, DialogContent, Divider, Grid, Typography } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import CustomButton from '../../../../../components/buttons/CustomButton';
import CustomSelect from '../../../../../components/customized/customselect/CustomSelect';
import CustomTextField from '../../../../../components/customized/customtextfield/CustomTextField';
import CustomCard from '../../../../../components/customcard/CustomCard';
import GoogleMap from '../../../../../components/maps/googlemap/GoogleMap';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import GoogleSearchBox from '../../../../../components/maps/googlesearchbox/GoogleSearchBox';
import GoogleCircle from '../../../../../components/maps/googlecircle/GoogleCircle';
import { useAppDispatch, useAppSelector } from '../../../../../../app/redux/hooks';
import {
  Location,
  addGeofenceAction,
  deactivateGeofence,
  deleteGeofence,
  getGeofencesAction,
  updateGeofenceAction
} from '../../../../../../features/yaantrac/redux/reducer/yaantracSlices/geofenceSlice';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import constants from '../../../../../../utils/constants';
import {
  CirclePropsF,
  updateFence,
  updateFenceById,
  updateIsShow
} from '../../../../../redux/reducer/commonSlices/circleSlice';
import {
  map,
  updateCenter as updateMapCenter,
  updateZoom
} from '../../../../../redux/reducer/commonSlices/mapSlice';
import CustomDialog from '../../../../../components/customdialog/CustomDialog';
import Loader from '../../../../../components/customized/customloader/CustomLoader';
import { updateToast } from '../../../../../redux/reducer/commonSlices/toastSlice';
import { getDevices } from '../../../../../../features/yaantrac/redux/reducer/yaantracSlices/reportSlice';
import CustomRadioButton from '../../../../../components/customized/customradiobutton/CustomRadioButton';
import GooglePolygon from '../../../../../components/maps/googlepolygon/GooglePolygon';
import {
  PolygonPropsF,
  updateIsShowDrawingManager,
  updateIsShowPolygon,
  updatePolygonFenceById,
  updatePolygonFences
} from '../../../../../redux/reducer/commonSlices/polygonSlice';
import {
  convertVehicleNo,
  findAddress,
  isValidPolygon,
  useAbort
} from '../../../../../../utils/commonFunctions';
import {
  createConnection,
  updateData
} from '../../../../../redux/reducer/commonSlices/websocketSlice';
import CustomIconButton from '../../../../../components/buttons/CustomIconButton';
import GoogleDrawingManager from '../../../../../components/maps/googledrawingManager/GoogleDrawingManager';
import { dashboardVehiclesStatusAction } from '../../../../../../features/yaantrac/redux/reducer/yaantracSlices/dashboardSlice';
import GoogleMarkers from '../../../../../components/maps/googlemarkers/GoogleMarkers';
import { analyticsActionByStatus } from '../../../../../../features/yaantrac/redux/reducer/yaantracSlices/analyticsSlice';
import './Geofence.scss';

const schema = yup.object().shape({
  geoZoneName: yup.string().required('Enter Geofence Name'),
  geoType: yup.string().required('Select type'),
  vehicle: yup.string().required('Select the Vehicle'),
  radius: yup.string().when('geoType', {
    is: 'circular',
    then: () =>
      yup
        .string()
        .required('Enter the Geofence Radius(KM)')
        .matches(
          /^(?=.)(?!0*[.]?0*$)(?:(?:0\.[1-9]|[1-4]?\d(?:\.\d{1,2})?|50(?:\.00?)?))$/,
          'Enter the radius between 0.01Km to 50Km'
        ),
    otherwise: () => yup.string().notRequired()
  }),
  location: yup.string().when('geoType', {
    is: 'circular',
    then: () => yup.string().required('Enter a Location'),
    otherwise: () => yup.array().notRequired()
  })
});

type PayLoad = {
  vehicleNumber?: string[];
  geoType: string;
  latAndLong: Location[];
  radius?: number | null;
  shapeColor: string;
};

export interface UpdatePayload {
  payload: PayLoad;
  geoZoneID: string;
  signal?: any;
}

function Geofence() {
  const [open, setOpen] = useState<boolean>(false);
  const [view, setView] = useState<boolean>(false);
  const [address, setAddress] = useState<any>(null);
  const [selectedGeofence, setSelectedGeofence] = useState<any>(null);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [geoZoneID, setGeoZoneID] = useState<any>();
  const [isDeviceDisabled, setIsDeviceDisabled] = useState<boolean>(false);
  const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
  const [isCircular, setIsCircular] = useState<boolean>(true);
  const [filter, setFilter] = useState('');
  const [vehicleNumber, setvehicleNumber] = useState<string>('');
  const [addVehicle, setAddVehicle] = useState<string | null>();
  const [vehicleLocation, setVehicleLocation] = useState([]);

  // function to dispatch state
  const dispatch = useAppDispatch();
  const createAbort = useAbort();

  const { data, isLoading, type } = useAppSelector(state => state?.geofences);
  const { polygonFences } = useAppSelector(state => state.polygon);
  const { connection, data: socketData } = useAppSelector(state => state.websocket);
  const allVehicleData = useAppSelector(state => state.dashboard);
  const allVehicleData2 = useAppSelector(state => state.analytics.dataByStatus);
  const { deviceList } = useAppSelector(state => state.devicelist);
  const { isShow, fences } = useAppSelector(state => state.circle);
  const abortController = useRef<AbortController | null>(null);

  const { handleSubmit, control, setValue, getValues, clearErrors, reset, setError } =
    useForm<any>({
      resolver: yupResolver(schema)
    });

  const filteredData = data
    ? data?.length > 0 &&
      data?.filter((item: any) => {
        const vehicleNumber = item?.vehicleNumber?.toLowerCase();
        const geofenceName = item?.geofenceName?.toLowerCase();
        return (
          vehicleNumber?.includes(filter?.toLowerCase()) ||
          geofenceName?.includes(filter?.toLowerCase())
        );
      })
    : [];

  const handleFilterChange = (event: any) => setFilter(event);

  const onSubmit = async (params: any) => {
    if (abortController.current) abortController.current.abort();
    abortController.current = new AbortController();
    const { signal } = abortController.current;
    if (params?.geoType === 'polygon') {
      if (!params?.location?.length && !isUpdate) {
        dispatch(
          updateToast({ show: true, severity: 'error', message: 'Please draw polygon' })
        );
        return;
      }

      if (!isValidPolygon(params?.location)) {
        dispatch(
          updateToast({
            show: true,
            severity: 'error',
            message: 'Please draw valid polygon'
          })
        );
        return;
      }
    }

    const updatedPolygon =
      params?.geoType === 'polygon' &&
      params?.location?.map((item: any) => ({
        lat: item?.lat,
        lng: item?.lng
      }));

    let latAndLong =
      params?.geoType === 'polygon'
        ? updatedPolygon
        : [
            {
              lat: address?.geometry
                ? address?.geometry?.location?.lat()
                : selectedGeofence?.latAndLongDetails[0]?.lat,
              lng: address?.geometry
                ? address?.geometry?.location?.lng()
                : selectedGeofence?.latAndLongDetails[0]?.lng
            }
          ];

    let payload = {
      geoZoneName: params?.geoZoneName?.toUpperCase(),
      geoType: params?.geoType,
      vehicleNumber: params?.vehicle,
      latAndLong: latAndLong,
      location:
        params?.geoType === 'circular'
          ? params?.location
          : await findAddress(params?.location[0]?.lat, params?.location[0]?.lng),
      radius: params?.geoType === 'circular' ? Number(params?.radius) : null,
      shapeColor: '#19A7CE'
    };

    if (!isUpdate) {
      await dispatch(addGeofenceAction(payload));
      setOpen(false);
      await dispatch(getGeofencesAction(signal));
    } else {
      if (abortController.current) abortController.current.abort();
      abortController.current = new AbortController();
      const { signal } = abortController.current;
      let updatePayload: UpdatePayload = {
        payload: payload,
        geoZoneID: geoZoneID,
        signal: signal
      };
      await dispatch(updateGeofenceAction(updatePayload));
      setOpen(false);
      await dispatch(getGeofencesAction(signal));
    }
    onClose();
  };

  const onUpdate = (params: any) => {
    const { vehicleNumber } = params;
    const circularGeofences = getGeofences(
      params?.vehicleNumber,
      'circular'
    ) as CirclePropsF[];
    const polygonGeofences = getGeofences(
      params?.vehicleNumber,
      'polygon'
    ) as PolygonPropsF[];

    const circularCoord = circularGeofences?.map((item: any) => item?.center);
    const polygonCoord = polygonGeofences?.map((item: any) => item?.paths)?.flat();

    dispatch(updateFence(circularGeofences));
    dispatch(updatePolygonFences(polygonGeofences));
    dispatch(updateZoom([...polygonCoord, ...circularCoord]));
    dispatch(updateMapCenter([...polygonCoord, ...circularCoord]));

    if (vehicleNumber) {
      const filteredMarker = allVehicleData2?.filter((value: any) => {
        return value?.id === vehicleNumber?.toLowerCase();
      });
      setVehicleLocation(filteredMarker);

      dispatch(map(filteredMarker));
    }

    if (params?.geoType === 'polygon') dispatch(updateIsShowDrawingManager(true));
    setIsCircular(params?.geoType === 'circular');
    setIsUpdate(true);
    setOpen(true);
    setIsDeviceDisabled(true);
    setValue('vehicle', params?.vehicleNumber?.toLowerCase());
    setValue('geoZoneName', params?.geofenceName);
    setSelectedVehicle(params?.vehicleNumber?.toLowerCase());
    if (params?.geoType === 'circular') {
      dispatch(updateIsShow(true));
      dispatch(
        updateFenceById({
          id: params?.geoZoneId,
          center: params?.latAndLongDetails?.[0],
          radius: params?.radius * 1000
        })
      );
      setValue('geoType', 'circular');
      setValue('location', params?.location ? params?.location : 'Chennai');
      setValue('radius', params?.radius);
      setAddress({
        formatted_address: params?.location ? params?.location : 'Chennai',
        latitude: params?.lat,
        longitude: params?.lng
      });
    } else {
      setValue('geoType', 'polygon');
      const [newFence] = data.filter((item: any) => item?.id === params?.id);
      dispatch(
        updatePolygonFenceById({
          id: params?.geoZoneId,
          paths: newFence?.latAndLongDetails
        })
      );
    }
    setGeoZoneID(params?.geoZoneId);
    setSelectedGeofence(params);
  };

  const mappedDeviceList = deviceList?.map((vehicle: any) => ({
    id: vehicle,
    label: vehicle.toUpperCase()
  }));

  const handleUpdateVehicleNo = [
    ...mappedDeviceList,
    { id: selectedVehicle, label: convertVehicleNo(selectedVehicle?.toUpperCase()) }
  ];

  const onView = (params: any) => {
    let { radius, latAndLongDetails, vehicleNumber } = params;
    console.log(vehicleNumber, 'VEHICLE NUMBERS');

    setSelectedVehicle(params?.vehicleNumber?.toLowerCase());
    setvehicleNumber(vehicleNumber);
    dispatch(updateIsShowDrawingManager(false));
    dispatch(updateMapCenter(latAndLongDetails));
    dispatch(
      updateFence([
        {
          id: params?.geoZoneId,
          center: params?.latAndLongDetails?.[0],
          radius: params?.radius * 1000
        }
      ])
    );
    dispatch(updateIsShow(true));

    if (vehicleNumber) dispatch(createConnection(vehicleNumber.toLowerCase()));
    if (vehicleNumber) {
      const filteredMarker: any = allVehicleData2?.filter((value: any) => {
        return value?.id === vehicleNumber?.toLowerCase();
      });

      dispatch(map(filteredMarker));
    }
    if (params?.geoType === 'polygon') {
      setIsCircular(false);
      dispatch(updateZoom(latAndLongDetails));
      dispatch(
        updatePolygonFences([{ id: params?.geoZoneId, paths: latAndLongDetails }])
      );
    } else {
      let newRadius = radius + radius / 2;
      let scale = newRadius / 500;
      let zoom = 5 - Math.log(scale) / Math.log(2);
      dispatch(updateZoom(zoom));
      setIsCircular(true);
    }
    if (params.isActive === 0) setView(false);
    else setView(true);
  };

  const onClose = () => {
    if (abortController.current) abortController.current.abort();
    setOpen(false);
    reset({ vehicle: '', location: '', radius: '' });
    setIsDeviceDisabled(false);
    setAddress(null);
    setSelectedVehicle(null);
    setSelectedGeofence(null);
    setIsUpdate(false);
    setIsCircular(true);
    dispatch(updateIsShowDrawingManager(false));
    dispatch(updateFence([]));
    dispatch(updatePolygonFences([]));
    dispatch(updateIsShowPolygon(true));
    dispatch(map([]));
    reset((formValues: any) => ({ ...formValues, geoZoneName: null }));
    setValue('geoType', 'circular');
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(position => {
        const { latitude: lat, longitude: lng } = position.coords;
        dispatch(map([{ id: 1, name: 'marker1', lat, lng }]));
      });
    }
  };

  function getGeofences(
    selected: string,
    type: 'circular' | 'polygon'
  ): CirclePropsF[] | PolygonPropsF[] {
    return data
      ? data
          .filter(
            (item: any) =>
              item?.geoType === type && item?.vehicleNumber === selected?.toUpperCase()
          )
          .map((item: any) => {
            return type === 'circular'
              ? {
                  id: item?.geoZoneId || item?.id,
                  center: {
                    lat: item.latAndLongDetails[0].lat,
                    lng: item.latAndLongDetails[0].lng
                  },
                  radius: item.radius * 1000
                }
              : {
                  id: item?.geoZoneId,
                  paths: item?.latAndLongDetails
                };
          })
      : [];
  }

  const onAddOrUpdate = useCallback(
    (selected: any) => {
      clearErrors('vehicle');
      setValue('location', '');
      setValue('radius', '');
      if (selected) dispatch(createConnection(selected.id));
      if (getValues('geoType') === 'polygon') dispatch(updateIsShowDrawingManager(true));
      else dispatch(updateIsShowDrawingManager(false));

      const polygonGeofences = getGeofences(
        selected?.label,
        'polygon'
      ) as PolygonPropsF[];
      dispatch(updatePolygonFences(polygonGeofences));

      const circularLocations = data
        ?.filter((item: any) => item?.geoType === 'circular')
        ?.filter((item: any) => item?.vehicleNumber === selected?.label)
        ?.map((item: any) => item.latAndLongDetails[0] || []);

      const geofences = getGeofences(selected?.label, 'circular') as CirclePropsF[];

      const polygonLocations = data
        ?.filter((item: any) => item.geoType === 'polygon')
        ?.filter((item: any) => item.vehicleNumber === selected?.label)
        ?.map((item: any) => item.latAndLongDetails || []);

      if (polygonLocations?.length > 0 || circularLocations?.length > 0) {
        dispatch(updateMapCenter([polygonLocations?.flat(), circularLocations].flat()));
        dispatch(updateZoom([polygonLocations?.flat(), circularLocations].flat()));
      }
      if (geofences?.length === 1 && geofences[0]?.radius) {
        let newRadius = geofences[0]?.radius + geofences[0]?.radius / 2;
        let scale = newRadius / 500;
        let zoom = 5 - Math.log(scale) / Math.log(2);
        dispatch(updateZoom(zoom));
      }
      dispatch(updateIsShow(true));
      dispatch(updateIsShowPolygon(true));
      dispatch(updateFence(geofences));
    },
    [data, polygonFences, isCircular]
  );

  const handleMapClick = async (e: any) => {
    if (isCircular && getValues('vehicle')) {
      const lat = e?.latLng?.lat();
      const lng = e?.latLng?.lng();
      let center = { lat, lng };

      if (vehicleLocation?.length > 0) {
        dispatch(map([...vehicleLocation, { id: 1, lat, lng, name: 'location' }]));
      } else {
        dispatch(map([{ id: 1, lat, lng, name: 'location' }]));
      }
      const fAdd = await findAddress(lat, lng);
      setAddress({
        geometry: {
          location: {
            lat: e?.latLng?.lat,
            lng: e?.latLng?.lng
          }
        },
        formatted_address: fAdd
      });
      setValue('radius', selectedGeofence?.radius * 1000);
      clearErrors('radius');
      if (selectedGeofence) {
        dispatch(
          updateFenceById({
            id: selectedGeofence?.geoZoneId,
            center,
            radius: selectedGeofence?.radius * 1000
          })
        );
      } else {
        const geofences = getGeofences(
          getValues('vehicle'),
          'circular'
        ) as CirclePropsF[];
        dispatch(updateFence([...geofences, { id: 'new', center, radius: 1000 }]));
      }
    }
    if (getValues('vehicle') === undefined || getValues('vehicle') === '') {
      dispatch(
        updateToast({
          show: true,
          message: 'Choose a vehicle before picking a map',
          severity: 'warning'
        })
      );
    }
  };

  const onDeactivate = async (params: any) => {
    if (abortController.current) abortController.current.abort();
    abortController.current = new AbortController();
    const { signal } = abortController.current;
    const payload = {
      id: params?.geoZoneId,
      signal: signal
    };
    await dispatch(deactivateGeofence(payload));
    await dispatch(getGeofencesAction(signal));
  };

  const onDelete = async (params: any) => {
    if (abortController.current) abortController.current.abort();
    abortController.current = new AbortController();
    const { signal } = abortController.current;
    await dispatch(deleteGeofence(params?.geoZoneId));
    await dispatch(getGeofencesAction(signal));
  };

  useEffect(() => {
    if (connection) {
      connection.onopen = () => {
        console.log('vehicle connected');
      };

      connection.onmessage = (e: any) => {
        console.log('message received', e);
        dispatch(updateData(JSON.parse(e?.data)));
      };

      connection.onclose = () => {
        console.log('connection closed');
      };
    }

    return () => {
      if (connection) connection.close();
    };
  }, [connection]);

  useEffect(() => {
    if (socketData && [socketData].length > 0) {
      const [filteredMarker]: any = allVehicleData?.data?.filter((value: any) => {
        return (
          value.id ===
          (socketData as { vehicle_number: any }).vehicle_number.toUpperCase()
        );
      });

      const convertedData = [socketData].map((item: any) => ({
        id: item.vehicle_number,
        lat: parseFloat(item.latitude),
        lng: parseFloat(item.longitude),
        name: filteredMarker?.name || 'car',
        info: {
          address: item?.address,
          speed: item.speed,
          status: 'Online',
          todayDistance: 0,
          totalDistance: item.total_distance,
          vehicleNumber: convertVehicleNo(item.vehicle_number.toUpperCase()),
          vehicleStatus: 'Parking'
        },
        type: 'delivery'
      }));

      if (vehicleNumber === (socketData as any)?.vehicle_number)
        dispatch(map(convertedData));
    } else {
    }
  }, [socketData]);

  useEffect(() => {
    if (address?.geometry?.location) {
      clearErrors('location');

      if (!getValues('vehicle')) {
        setError('vehicle', { message: 'Select Vehicle' });
        setAddress(null);
        setValue('location', null);
        return;
      }

      let center = {
        lat: address?.geometry?.location?.lat(),
        lng: address?.geometry?.location?.lng()
      };

      if (selectedGeofence) {
        setValue('radius', selectedGeofence?.radius);
        dispatch(
          updateFenceById({
            id: selectedGeofence?.geoZoneId,
            center,
            radius: selectedGeofence?.radius * 1000
          })
        );
      } else {
        const hasNew = fences.some((obj: any) => obj.id === 'new');
        if (hasNew) {
          const [newFence]: any = fences?.filter((obj: any) => obj.id === 'new');
          setValue('radius', newFence?.radius / 1000);
          dispatch(
            updateFenceById({
              id: newFence?.id,
              center,
              radius: newFence?.radius
            })
          );
        } else {
          setValue('radius', 1);
          dispatch(updateFence([...fences, { id: 'new', center, radius: 1000 }]));
        }
      }

      dispatch(updateMapCenter([center]));
      dispatch(updateZoom([center]));
      clearErrors('radius');
    }
    let formatted_address = address?.formatted_address;
    setValue('location', formatted_address);
  }, [address]);

  useEffect(() => {
    dispatch(updateIsShowDrawingManager(false));
    if (abortController.current) abortController.current.abort();
    abortController.current = new AbortController();
    const { signal } = abortController.current;

    dispatch(getGeofencesAction(signal));
    dispatch(analyticsActionByStatus({ vehicle: 'total', toast: false }));
    return () => {
      if (abortController.current) abortController.current.abort();
    };
  }, []);

  useEffect(() => {
    if (addVehicle) {
      const vehicleMarker = allVehicleData2?.filter((value: any) => {
        return value?.id === addVehicle;
      });
      dispatch(map(vehicleMarker));
      setVehicleLocation(vehicleMarker);
    }

    return () => {
      dispatch(map([]));
    };
  }, [addVehicle]);

  useEffect(() => {
    if (!isCircular) {
      const [newFence] = polygonFences.filter((item: any) =>
        selectedGeofence ? item?.id === selectedGeofence?.geoZoneId : item?.id === 'new'
      );
      setValue('location', newFence?.paths);
      clearErrors('location');
    }
  }, [polygonFences, isCircular, selectedGeofence]);

  useEffect(() => {
    dispatch(getDevices(createAbort().abortCall.signal));
    dispatch(dashboardVehiclesStatusAction({ arg1: 'total', arg2: false }));
    return () => {
      dispatch(map([]));
      createAbort().abortCall.abort();
    };
  }, []);

  return (
    <Box className='vehicle-mapping'>
      {isLoading && type === 'geofences' ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '400px'
          }}
        >
          <Loader />
        </Box>
      ) : (
        <Box>
          <Box className='title'>
            <CustomButton
              className='saveChanges'
              onClick={() => {
                setOpen(true);
                dispatch(updateIsShowDrawingManager(false));
                dispatch(map([]));
                setIsCircular(true);
                setValue('geoType', 'circular');
              }}
              category='Add New Geofence'
            />
          </Box>
          <Box sx={{ width: 200, float: 'right' }}>
            <CustomTextField
              name='search'
              control={control}
              id='filter-input'
              placeholder='Search...'
              value={filter}
              variant='standard'
              icon={<SearchOutlinedIcon color='primary' />}
              onChangeCallback={(e: any) => handleFilterChange(e)}
            />
          </Box>
          <Grid container spacing={2}>
            {filteredData?.length > 0 ? (
              filteredData?.map((item: any) => (
                <Grid key={item.id} item xs={12} sm={6} md={4} lg={3}>
                  <CustomCard
                    key={item.id}
                    type='geofence'
                    geoType={item.geoType}
                    id={item.id}
                    geofenceName={item.geofenceName}
                    vehicleNumber={item.vehicleNumber}
                    geofenceRadius={item.radius}
                    isActive={item.isActive}
                    location={item.location}
                    onView={() => onView(item)}
                    onDeactivate={() => onDeactivate(item)}
                    onUpdate={() => onUpdate(item)}
                    onDelete={() => onDelete(item)}
                  />
                </Grid>
              ))
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '200px'
                }}
              >
                {constants.NoDataFound}
              </Grid>
            )}
          </Grid>
        </Box>
      )}

      <Dialog open={open} className='dialog' sx={{ zIndex: 1, position: 'absolute' }}>
        <DialogContent>
          <Grid
            container
            sx={{
              flexDirection: { xs: 'column-reverse', md: 'row', sm: 'row' },
              gap: { lg: 1, md: 1, sm: 1 }
            }}
          >
            <Grid item xs={12} md={8} sm={8} lg={9}>
              <Box sx={{ width: '100%', height: '83vh' }}>
                <GoogleMap handleMapClick={handleMapClick} maplegend={true}>
                  {isShow && <GoogleCircle />}
                  <GoogleMarkers />
                  <GooglePolygon />
                  <GoogleDrawingManager updateID={selectedGeofence?.geoZoneId} />
                </GoogleMap>
              </Box>
            </Grid>
            <Divider orientation='vertical' variant='middle' flexItem />
            <Grid item xs={12} md={3.6} sm={3.6} lg={2.8} className='grid-form'>
              <Box
                sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                component='form'
                onSubmit={handleSubmit(onSubmit)}
              >
                <Typography className='custom-drawer-typo1'>
                  {constants.Geofence}
                </Typography>
                <Box className='closeIcon icon-position d-flex' onClick={onClose}>
                  <CustomIconButton category='CloseValue' />
                </Box>
                <CustomRadioButton
                  name='geoType'
                  control={control}
                  formlabel='Select Geofence Type'
                  radiobutton1='Circular'
                  radiobutton2='Polygon'
                  value1='circular'
                  value2='polygon'
                  disabled={isUpdate}
                  onChangeCallback={e => {
                    dispatch(map([]));
                    setValue('location', null);
                    if (getValues('vehicle'))
                      onAddOrUpdate({ label: getValues('vehicle')?.toUpperCase() });
                    setValue('geoType', e.target.value);
                    clearErrors();
                    if (e.target.value === 'circular') {
                      setIsCircular(true);
                      dispatch(updateIsShowDrawingManager(false));
                    } else {
                      setIsCircular(false);
                      if (getValues('vehicle') !== undefined)
                        dispatch(updateIsShowDrawingManager(true));
                    }
                  }}
                />

                <CustomTextField
                  id='geofence-name'
                  control={control}
                  name='geoZoneName'
                  label='Geofence Name'
                  placeholder='Geofence Name'
                />

                <CustomSelect
                  id='select-vehicle'
                  control={control}
                  label='Select Vehicle'
                  name='vehicle'
                  placeholder='Select Vehicle'
                  options={selectedVehicle ? handleUpdateVehicleNo : mappedDeviceList}
                  isDisabled={isDeviceDisabled}
                  onChanges={(e: any, selected: any) => {
                    setAddVehicle(selected?.id);
                    onAddOrUpdate(selected);
                  }}
                />

                {isCircular && (
                  <>
                    <GoogleSearchBox
                      id='new-test'
                      name='location'
                      control={control}
                      label='Search Location'
                      placeholder='Select Location'
                      value={address?.formatted_address}
                      setAddress={setAddress}
                    />

                    <CustomTextField
                      id='geofence-radius'
                      control={control}
                      name='radius'
                      label='Geofence Radius (KM)'
                      placeholder='Geofence Radius(KM)'
                      type='number'
                      defaultValue={selectedGeofence ? selectedGeofence?.radius : ''}
                      inputProps={{
                        maxLength: 4
                      }}
                      onChangeCallback={(e: string) => {
                        if (!getValues('location')) {
                          setError('location', { message: 'Search location' });
                          return;
                        }

                        if (selectedGeofence) {
                          const [selectedFence]: any = fences?.filter(
                            (item: any) => item?.id === selectedGeofence?.geoZoneId
                          );
                          dispatch(
                            updateFenceById({
                              id: selectedGeofence?.geoZoneId,
                              center: selectedFence?.center,
                              radius: e ? Number(e) * 1000 : selectedFence?.radius
                            })
                          );
                        } else {
                          const [newOne]: any = fences?.filter(
                            (item: any) => item?.id === 'new'
                          );
                          dispatch(
                            updateFenceById({
                              id: newOne?.id,
                              center: newOne?.center,
                              radius: e ? Number(e) * 1000 : 1000
                            })
                          );
                        }
                      }}
                    />
                  </>
                )}

                <Box sx={{ marginTop: '5%', display: 'flex', gap: '15px' }}>
                  <CustomButton
                    loading={
                      isLoading &&
                      (type === 'save-geofence' || type === 'update-geofence')
                    }
                    category={isUpdate ? 'Update' : 'Save'}
                    className='saveChanges'
                    type='submit'
                  />
                  <CustomButton className='cancel' category='Cancel' onClick={onClose} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {view && (
        <CustomDialog
          view={view}
          maplegend={true}
          handleViewClose={() => {
            setView(false);
            setSelectedVehicle(null);
            dispatch(updateIsShowDrawingManager(true));
            dispatch(updateIsShowPolygon(true));
            dispatch(updateFence([]));
            dispatch(updatePolygonFences([]));
            dispatch(map([]));
            if (connection) connection.close();
          }}
          type={!isCircular}
        />
      )}
    </Box>
  );
}

export default Geofence;
